import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  cloudinaryImageUrl,
  ratioOptions,
} from '@scentregroup/ui/tools/cloudinary/image'
import style from './index.module.scss'

const Image = ({ className, imageUrl, ratio, alt, bgSize, dataTestId }) => {
  if (!imageUrl) {
    return (
      <div className={className}>
        <div className={classNames(style.placeholder, style[ratio])} />
      </div>
    )
  }

  return (
    <img
      className={className}
      data-test-id={dataTestId}
      src={cloudinaryImageUrl({
        src: imageUrl,
        ratio,
        numberofItems: 1,
        bgSize,
      })}
      alt={alt}
    />
  )
}

Image.defaultProps = {
  alt: '',
}

Image.propTypes = {
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  ratio: PropTypes.oneOf(ratioOptions),
  alt: PropTypes.string,
  bgSize: PropTypes.oneOf(['cover', 'contain']),
  dataTestId: PropTypes.string,
}

export default Image
